import { PrintReceiptPosBody } from 'front-office/view-models/print-receipt-pos-page';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<PrintReceiptPosBody, keyof PrintReceiptPosBody>[] = [
  {
    id: 'number',
    label: 'Numero servizio',
  },
  {
    id: 'type',
    label: 'Tipo certificato',
  },
  {
    id: 'modality',
    label: 'Modalità rilascio',
  },
  {
    id: 'amount',
    label: 'Importo',
  },
  {
    id: 'fiscalCode',
    label: 'Cod fiscale intestatario',
  },
  {
    id: 'dateCertificate',
    label: 'Data certificato',
  },
  {
    id: 'operator',
    label: 'Operatore',
  },
  {
    id: 'service',
    label: 'Servizio',
  },
  {
    id: 'ann',
    label: 'Ann',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
